import { FC } from "react";
import Restricted from "@/consumer/restricted";
import GlobalSettingsTable from "@/components/globalSettings/globalSettingsTable";

const GlobalSettingsList: FC = () => {
  return (
    <Restricted permissionRequired="frontend_view_setting">
      <GlobalSettingsTable />
    </Restricted>
  );
};

export default GlobalSettingsList;
